import axios from 'axios';
import AuthService from './AuthService';
import { API_BASE_URL } from './configurations/ServiceConfig';
import { toast } from 'react-toastify';

export async function listarProdutosFiltrados(filtro, page, size) {
    try {
        const response = await axios({
            baseURL: API_BASE_URL,
            method: 'POST',
            url: '/produto/find',
            withCredentials: true,
            data: {
                nome: filtro.nome,
                categoria: filtro.categoria,
                subCategoria: filtro.subCategoria,
                marca: filtro.marca,
                menorPreco: filtro.menorPreco,
                maiorPreco: filtro.maiorPreco,
                avaliacao: filtro.avaliacao,
                page: page,
                size: size,
            },
            timeout: 10000,
        });

        if (response.status !== 200 && response.status !== 204) {
            throw new Error('Erro ao filtrar produtos.');
        }

        return response.data;
    } catch (error) {
        if (
            error.response &&
            error.response.data &&
            error.response.data.error
        ) {
            console.error(error.response.data.error);
        }
        throw error;
    }
}

export async function listarProdutosComDesconto() {
    try {
        const response = await axios({
            baseURL: API_BASE_URL,
            method: 'GET',
            url: '/produto/desconto',
            timeout: 10000,
        });

        if (response.status !== 200 && response.status !== 204) {
            throw new Error('Erro ao listar produtos com desconto.');
        }

        return response.data;
    } catch (error) {
        if (
            error.response &&
            error.response.data &&
            error.response.data.error
        ) {
            toast.error(error.response.data.error);
        } else {
            toast.error('Erro ao listar produtos.');
        }
        throw error;
    }
}

export async function cadastrarProduto(produto) {
    try {
        const response = await axios({
            baseURL: API_BASE_URL,
            method: 'POST',
            url: '/produto',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                Authorization: AuthService.getToken(),
            },
            data: {
                nome: produto.nome,
                valor: produto.preco,
                descricao: produto.descricao,
                desconto: produto.desconto?.toString() || '0',
                cor: produto.cor,
                modelo: produto.modelo,
                imagemPrincipal: produto.imagemPrincipal,
                imagens: produto.imagens,
                subCategoria: produto.subCategoria,
                peso: produto.peso,
                altura: produto.altura,
                comprimento: produto.comprimento,
                largura: produto.largura,
                fabricante: produto.fabricante,
                fornecedor: produto.fornecedor,
            },
            timeout: 10000,
        });

        if (response.status !== 201) {
            return false;
        }

        return true;
    } catch (error) {
        console.error('Erro ao cadastrar produto:', error);
        if (error.response?.data?.error) {
            toast.error(error.response.data.error);
        } else {
            toast.error('Erro ao cadastrar produto.');
        }
        return false;
    }
}

export async function updateProduto(produto, id) {
    try {
        const response = await axios({
            baseURL: API_BASE_URL,
            method: 'PUT',
            url: `/produto/${id}`,
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                Authorization: AuthService.getToken(),
            },
            data: {
                nome: produto.nome,
                descricao: produto.descricao,
                valor: produto.preco,
                desconto: produto.desconto?.toString() || '0',
                cor: produto.cor,
                modelo: produto.modelo,
                imagemPrincipal: produto.imagemPrincipal,
                imagens: produto.imagens,
                categoria: produto.categoria,
                subCategoria: produto.subCategoria,
                fabricante: produto.fabricante,
                altura: produto.altura,
                comprimento: produto.comprimento,
                largura: produto.largura,
                peso: produto.peso,
                fornecedor: produto.fornecedor,
            },
            timeout: 10000,
        });

        if (response.status !== 200 && response.status !== 204) {
            return false;
        }

        return true;
    } catch (error) {
        if (
            error.response &&
            error.response.data &&
            error.response.data.error
        ) {
            console.error(error.response.data.error);
        }
        return false;
    }
}

export async function getProdutoById(id) {
    try {
        const response = await axios({
            baseURL: API_BASE_URL,
            url: `/produto/${id}`,
            timeout: 10000,
        });
        return response.data;
    } catch (error) {
        console.error('Erro ao obter detalhes do produto:', error);
        return null;
    }
}
